import styled from 'styled-components'

export const Container = styled.div``

export const BannerCapTorcedor = styled.div`
  display: flex;
  margin: 24px 0 32px;

  img {
    width: 100%;
    height: auto;
  }
`
